module.exports = __webpack_public_path__ + "img/4.7f8c929a.jpg";